import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Helper } from '../common/helpers/Helper';
import { Grid } from '@material-ui/core';
import { Mp4Layout } from './Mp4Layout';
import { YoutubeLayout } from './YoutubeLayout';

export class MultiLayout extends Component {
  // TODO: link is hardcoded
  videoLink = 'https://d3txy5owctt379.cloudfront.net/1700460473531/48097dc0-93fb-11ee-b6f8-df39334f6afb.mp4'
  constructor() {
    super()
  }
  render() {
    return (
      <div className={css(Styles.contentHolderFull)}>
        <Grid container spacing={1} >
          {/* Mp4 */}
          <Grid item xs={12} md={6}>
            <Mp4Layout containerStyle={Styles.containerStyle}></Mp4Layout>
          </Grid>
          <Grid item xs={12} md={6}>
            <YoutubeLayout videoHeight={Styles.youtubeVideoHeight}></YoutubeLayout>
          </Grid>
          {/* Scroll Text */}
          <Grid item xs={12} md={12}>
            <section className={css(Styles.early, Styles.earlyExtra)}>
              <article className={css(Styles.article, Styles.articleExtra)}>
                <marquee className={css(Styles.ribbon)} behavior='scroll' direction='left'>{Helper.getString('scrollText')}</marquee>
              </article>
            </section>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  containerStyle:{
    height: '100%',
    minHeight: '50vh'
  },
  contentHolderFull: {
    maxHeight: '100vh',
    overflow: 'hidden',
    width: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
    background: '#000'
  },
  youtubeVideoHeight:{
    height:'100%',
    maxHeight:'100%',
    minHeight:'50vh'
  }, // Scrolling Text -- Start --
  article: {
    color: 'rgb(255, 255, 255) !important',
    display: 'flex !important',
    // minHeight: '4em !important',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  exampleLeft: {
    whiteSpace: 'nowrap',
    position: 'absolute',
    textTransform: 'uppercase',
    WebkitAnimation: 'textScrollRight 8s linear infinite',
    animation: 'textScrollRight 8s linear infinite alternate'
  },
  exampleRight: {
    whiteSpace: 'nowrap',
    position: 'absolute',
    top: '2em',
    opacity: 0.4,
    textTransform: 'uppercase',
    WebkitAnimation: 'textScrollLeft 8s linear infinite',
    animation: 'textScrollLeft 8s linear infinite alternate'
  },
  early: {
    animation: 'fadeIn ease-in 1',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '50vh'
  },
  pdfBlock:{
    display: 'flex',
    maxHeight: '400px !important',
    overflow: 'auto',
    justifyContent: 'center'
  },
  earlyExtra:{
    display: 'flex',
    height: '100%',
    fontSize: '4em'
  },
  articleExtra:{
    background: 'cadetblue'
  },
  ribbon:{
    padding: '1rem 0',
    borderTop: 'dashed',
    borderBottom: 'dashed'
  },
  pdfContainer:{
    maxHeight: '50vh'
  },
  displayBlock:{
    background: '#000',
    width: '100%'
  },
  singlePageBlock:{
    height: '100vh',
    width: '100vw'
  }
})



// WEBPACK FOOTER //
// ./src/screens/MultiLayout.js